import { Component, Input, ViewChild } from '@angular/core';
import { BaseEntity } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { EnumPageDisplayModes, EnumPageEntitySources, EnumMessageBoxTypes, EnumWindowSizes } from '@core/framework/sysenums.enum';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { MessageBoxCustomButton } from '@base/classes/BaseClasses';
import { PageButtonsComponent } from '@ui/layouts/componentlayouts/page-buttons/pagebuttons.component';

class State {
    ExtraButtons: MessageBoxCustomButton[];
    OKButtonText: string;
    OKButtonTabIndex: number;
    CancelButtonText: string;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-messageboxdialog',
    templateUrl: './messageboxdialog.component.html',
    styleUrls: ['./messageboxdialog.component.scss']
})
export class MessageBoxDialogComponent extends BasePageComponent<BaseEntity, State>
{
    @ViewChild('pageButtons') pageButtons: PageButtonsComponent;

    @Input() Title: string;
    @Input() Prompt: string;
    @Input() Buttons: MessageBoxCustomButton[];
    @Input() Width: EnumWindowSizes;
    @Input() Type: EnumMessageBoxTypes = EnumMessageBoxTypes.OK;
    @Input() IsHideCancel: boolean;
     
    constructor(A: ServiceBagService) {
        super(A, 'MessageBoxDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    protected override OnInitComponent(): void {
        if (!this.Width) {
            this.Width = this.A.Screen.IsDesktop() ? EnumWindowSizes.WindowXSmall : EnumWindowSizes.WindowLarge;
        }
    }

    protected override OnInitTitle() {
        return this.Title;
    }

    override GetDefaultTitle() {
        const moduleName = this.GetFirstModuleName();
        return this.A.ResourcesService.RC('AppTitles.Messages', moduleName);
    }

    //Prepare buttons
    override OnInitComponentFinished() {

        //Preset the types
        switch (this.Type) {
            case EnumMessageBoxTypes.OK:
                this.State.OKButtonText = this.RC('genOK');
                this.State.CancelButtonText = this.RC('genCancel');
                this.State.ExtraButtons = undefined;
                break;
            case EnumMessageBoxTypes.YesNo:
                this.State.OKButtonText = this.RC('genYes');
                this.State.CancelButtonText = this.RC('genNo');
                this.State.ExtraButtons = undefined;
                break;
            case EnumMessageBoxTypes.Custom:
                const [button] = this.Buttons
                this.State.OKButtonText = button.Text;
                this.State.OKButtonTabIndex = button.TabIndex;

                if (button.TabIndex) {
                    setTimeout(() => {
                        this.pageButtons.okBtnRef.btn.instance.focus()
                    }, 500)
                }

                // this.State.CancelButtonText = this.RC('genCancel');
                this.pageButtons.CloseButtonHidden = true;
                this.State.ExtraButtons = this.Buttons.slice(1);
                // this.Width = EnumWindowSizes.WindowAutoSize;
                break;
        }
    }
}
